<article [class.is-mobile]="isMobile()">
  @if (message()) {
    <div class="error-message back-{{ messageColour }}" [class.new-msg]="flashMessage">{{ message() }}</div>
  }
  <main>
    <section>
      <div class="login">
        <div [class.is-inputting]="_inputFocus()">
          <img class="logo" src="assets/svg/4d_logo_{{ theme() }}.svg" width="140px" alt="logo" />
        </div>
        <div>
          <div class="form">
            <div>
              @if (tokenId()) {
                <div class="hero">
                  <h3>Please reset your password.</h3>
                </div>
              }

              <div>
                <div class="form-group">
                  <label>Email</label>
                  <input class="fourd" #email [(ngModel)]="user.email" name="email" (focus)="inputFocus()" />
                </div>

                <div class="form-group">
                  <label>Password</label>
                  <input class="fourd" #password id="password" name="password" [(ngModel)]="user.password" [type]="showPassword ? 'text' : 'password'" />
                </div>

                @if (tokenId()) {
                  <div class="form-group">
                    <label>Confirm Password</label>
                    <input class="fourd" [(ngModel)]="newPassword" [type]="showPassword ? 'text' : 'password'" name="password" />
                  </div>
                }

                <div>
                  <span class="can-click" (click)="showPassword = !showPassword"><i class="mdi" [class.mdi-checkbox-marked-outline]="showPassword" [class.mdi-checkbox-blank-outline]="!showPassword"> </i> Show Password </span>
                </div>

                <div class="form-group mt-1">
                  <button (click)="login()" type="submit" class="btn btn-primary btn-block">
                    @if (!tokenId()) {
                      @if (state() === 0) {
                        <span>Login</span>
                      } @else {
                        <span>
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                      }
                    }
                    @if (tokenId()) {
                      <span>Update password</span>
                    }
                  </button>
                </div>

                <div class="secondary-actions forgot-password" [hidden]="siteDown || tokenId()">
                  @if (isMobile()) {
                    <app-button label="Forgot Password" (click)="forgotPassword()" />
                  } @else {
                    <a (click)="forgotPassword()" class="btn" [class.btn-secondary]="!attempts" [class.btn-success]="attempts">
                      @if (isProcessingForgotPassword()) {
                        <span>Sending link...</span>
                      } @else {
                        <span class="forgot-password">Forgot password?</span>
                      }
                    </a>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="award">
            <img src="https://s3.eu-west-2.amazonaws.com/4d-images-cms/pfm-awards-354x222.png" />
            <img src="https://s3.eu-west-2.amazonaws.com/4d-images-cms/ssip.jpg" class="ssip" />
          </div>
          <!--<div class="ingested">{{ingested}} packets of telemetry processed by the 4D platform.</div> -->
        </div>
      </div>
    </section>
    <section>
      <div class="news">
        @if (!cmsItems()) {
          <div class="placeholder">
            <h1>4D News</h1>
          </div>
        } @else {
          @for (feature of cmsItems(); track $index) {
            <div>
              <app-cms-item [item]="feature" theme="light" [showDate]="false"></app-cms-item>
            </div>
          }
        }
      </div>
    </section>
  </main>
</article>
